import { render, staticRenderFns } from "./NeedsDashboard.vue?vue&type=template&id=11a938eb&scoped=true&"
import script from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsDashboard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NeedsDashboard.vue?vue&type=style&index=0&id=11a938eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a938eb",
  null
  
)

export default component.exports